import { render, staticRenderFns } from "./OnboardingCreate.vue?vue&type=template&id=756a77bd"
import script from "./OnboardingCreate.vue?vue&type=script&lang=js"
export * from "./OnboardingCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports